import React, {useEffect} from 'react'
import {useState} from 'react'
import './preview.less'
import {ObsKeyToURL} from '../../api/utils'
import {LessonAnnex} from '../../api/course'

interface Props {
  previewFile: LessonAnnex
}
const PreviewDocument: React.FC<Props> = ({previewFile}) => {
  useEffect(() => {
    switch (previewFile.suffix) {
      case 'ppt':
      case 'pptx':
        setNum(5)
        break
      default:
        setNum(3)
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewFile.lesson_annex_id])
  const [previewFileNum, setNum] = useState(0)
  return (
    <div className="pdf-content-group">
      <iframe
        src={`http://ow365.cn/?i=25449&n=${previewFileNum}&ssl=1&htool=0&furl=${ObsKeyToURL(
          previewFile.url
        )}`}
        className="preview-iframe"
        title="preview-document"
      ></iframe>
    </div>
  )
}
export default PreviewDocument
